import * as yup from 'yup'
import { REGEX_ONLY_NUMBER, REGEX_PASSWORD, REGEX_PHONE } from '../constants/regex'

yup.addMethod(yup.string, 'password', function (message) {
  return this.matches(REGEX_PASSWORD, {
    message: message || 'Mật khẩu phải có ít nhất 6 ký tự',
    excludeEmptyString: true,
  })
})

yup.addMethod(yup.string, 'onlyNumber', function (message) {
  return this.matches(REGEX_ONLY_NUMBER, {
    message,
    excludeEmptyString: true,
  })
})
yup.addMethod(yup.string, 'phoneNumber', function (message) {
  return this.matches(REGEX_PHONE, {
    message,
    excludeEmptyString: true,
  })
})
declare module 'yup' {
  interface StringSchema {
    password: (message?: any) => yup.StringSchema
    onlyNumber: (message: any) => yup.StringSchema
    phoneNumber: (message: any) => yup.StringSchema
  }
}

export default yup
